export const DATE_DISPLAY_LOCALE = 'en-US';
export const TIMEZONE_FALLBACK = [
    'Asia/Ho_Chi_Minh',
    'Asia/Bangkok',
    'Asia/Singapore',
    'Asia/Kuala_Lumpur',
    'Asia/Jakarta',
    'Asia/Manila',
    'Asia/Taipei',
    'Asia/Hong_Kong',
    'Asia/Seoul',
    'Asia/Tokyo',
    'Asia/Kolkata',
    'Asia/Dubai',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'UTC',
];
const DEFAULT_DATE_TIME_OPTIONS = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
};
export function getClientTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export function formatInTimezone(value, timezone, options) {
    if (value == null || value === '')
        return '—';
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime()))
        return '—';
    return new Intl.DateTimeFormat(DATE_DISPLAY_LOCALE, {
        timeZone: timezone,
        ...DEFAULT_DATE_TIME_OPTIONS,
        ...options,
    }).format(date);
}
export function formatTimeInTimezone(value, timezone) {
    return formatInTimezone(value, timezone, {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: '2-digit',
        minute: '2-digit',
        second: undefined,
    });
}
export function formatDateInTimezone(value, timezone) {
    return formatInTimezone(value, timezone, {
        hour: undefined,
        minute: undefined,
        second: undefined,
    });
}
